// Mapa de importaciones de imágenes para integraciones
import boutiqueSpeakersImage from '@/assets/images/integrations/boutique_speakers.png'
import brandtrackBoxImage from '@/assets/images/integrations/brandtrack_box.png'
import cloudbedsImage from '@/assets/images/integrations/cloudbeds.svg'
import coverManagerImage from '@/assets/images/integrations/cover_manager.svg'
import eatappImage from '@/assets/images/integrations/eatapp.svg'
import followupImage from '@/assets/images/integrations/followup.svg'
import footTrafficImage from '@/assets/images/integrations/foot_traffic.svg'
import footfallcamImage from '@/assets/images/integrations/footfallcam.svg'
import fudoImage from '@/assets/images/integrations/fudo.svg'
import hostmeImage from '@/assets/images/integrations/hostme.svg'
import klienteTechImage from '@/assets/images/integrations/kliente_tech.svg'
import lastappImage from '@/assets/images/integrations/lastapp.svg'
import lightspeedImage from '@/assets/images/integrations/lightspeed.svg'
import opentableImage from '@/assets/images/integrations/opentable.svg'
import oracleImage from '@/assets/images/integrations/oracle.svg'
import pokenImage from '@/assets/images/integrations/poken.svg'
import resdiaryImage from '@/assets/images/integrations/resdiary.svg'
import retailNextImage from '@/assets/images/integrations/retail_next.svg'
import sevenroomsImage from '@/assets/images/integrations/sevenrooms.svg'
import squareImage from '@/assets/images/integrations/square.svg'
import tecbrainImage from '@/assets/images/integrations/tecbrain.svg'
import toastImage from '@/assets/images/integrations/toast.svg'
import vCountImage from '@/assets/images/integrations/v-count.svg'
import weatherImage from '@/assets/images/integrations/weather.svg'
import yelpImage from '@/assets/images/integrations/yelp.svg'

// Mapa de rutas a importaciones
const imageMap: Record<string, string> = {
	'assets/images/integrations/weather.svg': weatherImage,
	'assets/images/integrations/foot_traffic.svg': footTrafficImage,
	'assets/images/integrations/fudo.svg': fudoImage,
	'assets/images/integrations/cover_manager.svg': coverManagerImage,
	'assets/images/integrations/retail_next.svg': retailNextImage,
	'assets/images/integrations/oracle.svg': oracleImage,
	'assets/images/integrations/footfallcam.svg': footfallcamImage,
	'assets/images/integrations/lastapp.svg': lastappImage,
	'assets/images/integrations/v-count.svg': vCountImage,
	'assets/images/integrations/tecbrain.svg': tecbrainImage,
	'assets/images/integrations/followup.svg': followupImage,
	'assets/images/integrations/hostme.svg': hostmeImage,
	'assets/images/integrations/square.svg': squareImage,
	'assets/images/integrations/yelp.svg': yelpImage,
	'assets/images/integrations/eatapp.svg': eatappImage,
	'assets/images/integrations/opentable.svg': opentableImage,
	'assets/images/integrations/toast.svg': toastImage,
	'assets/images/integrations/lightspeed.svg': lightspeedImage,
	'assets/images/integrations/sevenrooms.svg': sevenroomsImage,
	'assets/images/integrations/resdiary.svg': resdiaryImage,
	'assets/images/integrations/cloudbeds.svg': cloudbedsImage,
	'assets/images/integrations/kliente_tech.svg': klienteTechImage,
	'assets/images/integrations/poken.svg': pokenImage,
	'assets/images/integrations/boutique_speakers.png': boutiqueSpeakersImage,
	'assets/images/integrations/brandtrack_box.png': brandtrackBoxImage,
}

/**
 * Obtiene la URL de la imagen importada basada en la ruta del JSON
 * @param iconPath - Ruta de la imagen desde el JSON (ej: "assets/images/integrations/weather.svg")
 * @returns URL de la imagen importada o una imagen por defecto si no se encuentra
 */
export const getIntegrationImage = (iconPath: string): string => {
	return imageMap[iconPath] || '/src/assets/images/default-image.svg'
}
